import { useContext, useState } from 'react';
import { AppContext } from '../App';
import api from '../api';

const OPTIONS = [
  {
    id: 'genro',
    icon: '🧾',
    title: 'Genro only',
    desc: 'Documents, permits and legal workflows',
  },
  {
    id: 'incubator',
    icon: '🚀',
    title: 'Workify Incubator only',
    desc: 'Work through incubator with proformas and payouts',
  },
  {
    id: 'accounting',
    icon: '🏦',
    title: 'Workify Accounting only',
    desc: 'Own company accounting and taxes',
  },
  {
    id: 'combo',
    icon: '🧩',
    title: 'Combo',
    desc: 'Genro + Incubator + Accounting access',
  },
];

export default function EcosystemModeSelect() {
  const { setPage, setUser, user } = useContext(AppContext);
  const [saving, setSaving] = useState(false);

  async function selectMode(mode) {
    if (saving) return;
    setSaving(true);
    try {
      await api.post('/onboarding/select-ecosystem', { mode });
      setUser(prev => ({
        ...prev,
        ecosystem_mode: mode,
        has_genro: mode === 'genro' || mode === 'combo',
        has_workify_incubator: mode === 'incubator' || mode === 'combo',
        has_workify_accounting: mode === 'accounting' || mode === 'combo',
      }));

      if (mode === 'accounting') {
        setPage('own_company_onboarding');
      } else if (mode === 'incubator' || mode === 'combo') {
        setPage('client_onboarding');
      } else {
        setPage('dashboard');
      }
    } catch (e) {
      console.error('Failed to save ecosystem mode', e);
      alert(e?.response?.data?.detail || e?.userMessage || 'Cannot save selection');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="onboarding-flow">
      <div className="onboarding-step">
        <div className="model-icon">🧭</div>
        <h1>What do you need?</h1>
        <p className="model-desc">Choose your product mode. You can update it later with admin.</p>

        <div className="type-cards" style={{ marginTop: 24 }}>
          {OPTIONS.map(opt => {
            const selected = user?.ecosystem_mode === opt.id;
            return (
              <div
                key={opt.id}
                className="type-card"
                onClick={() => selectMode(opt.id)}
                style={{
                  cursor: saving ? 'wait' : 'pointer',
                  opacity: saving ? 0.7 : 1,
                  border: selected ? '1px solid rgba(99,102,241,0.7)' : undefined,
                }}
              >
                <div className="type-icon">{opt.icon}</div>
                <h3>{opt.title}</h3>
                <p style={{ fontSize: 13, opacity: 0.85 }}>{opt.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
